import { Box, Button, styled } from '@mui/material';

export const ButtonsRow = styled(Box)<{ isPostComment?: boolean }>`
  position: absolute;
  bottom: 18px;
  right: ${({ isPostComment }) => (isPostComment ? '20px' : '20px')};
  display: flex;
  gap: 8px;
  align-items: center;
  @media (max-width: 1023px) {
    bottom: 18px;
    right: 6px;
  }
`;

export const CancelBtn = styled(Button)`
  text-transform: none;
  border-radius: 4px;
  padding: 5px 32px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.p080};
  border-color: ${({ theme }) => theme.palette.primary.grey};

  &:hover {
    background: ${({ theme }) => theme.palette.white.p100};
    border-color: ${({ theme }) => theme.palette.primary.grey};
  }
  @media (max-width: 1023px) {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const SubmitBtn = styled(Button)`
  text-transform: none;
  @media (max-width: 1023px) {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
`;
